export default {
  enabled: process.env.NEXT_PUBLIC_MIXPANEL_ENABLED,
  token: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
  debug: process.env.NEXT_PUBLIC_MIXPANEL_DEBUG,
}
